import { HeroForm } from "../../components/HeroForm/HeroForm";

export default function NewHero() {
  return <HeroForm />;
}
